/**
 * excludeTestPref.ts — Home tabs H-3b (RULED 2026-10-18): the "hide test
 * deals" preference, device-local in localStorage under the gss.pref.
 * namespace (the sidebarCollapsedPref precedent), default OFF.
 *
 * It is a stand-in for the spec's server-side user preference
 * (exclude_test_deals, §3.1 / §6): per device, never per account, and read
 * back by nothing but Sales Home. Reads and writes go through draftStorage,
 * so a blocked or full storage is NON-FATAL — a failed read is "off".
 */
import { readDraft, writeDraft } from './draftStorage'

export const EXCLUDE_TEST_DEALS_KEY = 'gss.pref.excludeTestDeals'

export function readExcludeTestDeals(): boolean {
  return readDraft<unknown>(EXCLUDE_TEST_DEALS_KEY) === true
}

export function writeExcludeTestDeals(on: boolean): void {
  writeDraft(EXCLUDE_TEST_DEALS_KEY, on)
}
